import ConnectedBreadCardModule from './ConnectedBreadCardModule';
export default ConnectedBreadCardModule;
